module.exports = __webpack_public_path__ + "components/forecast-table/static/rainfall-673a1c95eeb98959384c157e663076ac.jpg";